import axios from 'axios';
import type { TFunction } from 'i18next';

interface CommitErrorDetail {
  field: string | null;
  message: string;
}

function readFirstErrorDetail(caughtError: unknown): CommitErrorDetail | undefined {
  if (axios.isAxiosError(caughtError) === false || caughtError.response === undefined) {
    return undefined;
  }
  const responseData = caughtError.response.data;
  if (responseData === null || typeof responseData !== 'object') {
    return undefined;
  }
  const details = (responseData as { details?: unknown }).details;
  if (Array.isArray(details) === false || details.length === 0) {
    return undefined;
  }
  return (details as CommitErrorDetail[])[0];
}

export function translateImportIssueCode(t: TFunction, code: string): string {
  return t('clientImport:issues.' + code, { defaultValue: '' });
}

export function resolveCommitErrorMessage(t: TFunction, caughtError: unknown): string {
  const firstDetail = readFirstErrorDetail(caughtError);
  if (firstDetail === undefined) {
    return '';
  }
  if (firstDetail.field === null) {
    return firstDetail.message;
  }
  const translated = translateImportIssueCode(t, firstDetail.field);
  return translated.length > 0 ? translated : firstDetail.message;
}
